import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ChatFlowIcon from 'assets/icons/chatFlowMono.svg';
import AnimatedChatFlowIcon from 'components/@home/@settings/Tabs/Agents/AnimatedChatFlowIcon';
import { getAgentColorStyle } from 'components/@home/@settings/Tabs/Agents/agentColorPalette';
import { bool, number, object } from 'prop-types';
import React from 'react';

const iconStyle = {
  display: 'block',
  width: '58%',
  height: 'auto',
  position: 'relative',
  zIndex: 1,
  overflow: 'visible',
};

const AgentAvatar = ({ flow = null, size = 48, animated = false }) => {
  const theme = useTheme();
  const { bg, fg, highlight, glow } = getAgentColorStyle(flow, theme.palette.mode);
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const active = animated && !reduceMotion;

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: '50%',
        overflow: 'hidden',
        width: size,
        height: size,
        color: fg,
        background: `radial-gradient(circle at 32% 28%, ${highlight} 0%, ${bg} 70%)`,
        boxShadow:
          size >= 64 ? `0 ${size * 0.08}px ${size * 0.16}px -${size * 0.06}px ${glow}` : 'none',
      }}
      aria-hidden
    >
      {active ? <AnimatedChatFlowIcon style={iconStyle} /> : <ChatFlowIcon style={iconStyle} />}
    </Box>
  );
};

AgentAvatar.propTypes = {
  flow: object,
  size: number,
  animated: bool,
};

export default AgentAvatar;
